<template>
  <div id="overlay" @click="updateMainDataCancel" >
    <div id="content" @click="stopPropagation" >
      <h1>Update</h1>
      <div class="outline-vertical">
        <div class="block-vertical">
          <!-- val01 -->
          <div class="input-holder">
            <input class="inputText-common" type="text" placeholder="val01" v-model="item.val01" />
          </div>
          <!-- val02 -->
          <div class="input-holder">
            <input class="inputText-common" type="text" placeholder="val02" v-model="item.val02" />
          </div>
          <!-- val03 -->
          <div class="input-holder">
            <textarea class="textarea-common" placeholder="val03" v-model="item.val03" ></textarea>
          </div>
          <!-- val04 -->
          <div class="input-holder">
            <vue-tags-input class="textarea-common" placeholder="val04"
              v-model="tag"
              :tags="tags"
              :add-on-key="[13, ',']"
              :seperators="[',']"
              :autocomplete-items="tagsForAutoCompleteFiltered"
              @tags-changed="newTags => tags = newTags"
            />
          </div>
        </div>
        <div class="block-vertical">
          <div class="block-horizontal">
            <div class="button-holder">
              <button class="button-cancel" @click="updateMainDataCancel" >cancel</button>
            </div>
            <div class="button-holder">
              <button class="button-normal" @click="updateMainDataFix(item.id)" >update!!</button>
            </div>
          </div>
        </div>
        <div class="block-vertical">
          <hr class="hr-border" />
        </div>
        <div class="block-vertical">
          <div class="block-vertical">
            <div class="input-holder">
              <input class="input-imgUpdateDel" type="file" accept="image/png" @change="choiceImageData" />
            </div>
            <div class="block-horizontal">
              <div class="button-holder">
                <button class="button-mini-normal" @click="updateImageData(item.id)" >upd</button>
              </div>
              <div class="button-holder">
                <button class="button-mini-attention" @click="deleteImageData(item.id)" >del</button>
              </div>
            </div>
          </div>
        </div>
        <div class="block-vertical">
          <div class="div-procMsg-normal" v-if="procMsgNormal" >{{ procMsgNormal }}</div>
          <div class="div-procMsg-attention" v-if="procMsgAttention" >{{ procMsgAttention }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// データモジュール
import { MyData } from '@/my-modules/my-data'
// タグ機能モジュール(Vue Tags Input)
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'ModalUpdate',

  components: {
    VueTagsInput
  },

  props: ['modalItem', 'modalTagsForAutoComplete'],

  data: function () {
    return {
      item: '',
      tag: '',
      tags: [],
      tagsForAutoComplete: [],
      imageFile: '',
      idToken: '',
      procMsgNormal: null,
      procMsgAttention: null
    }
  },

  mounted: function () {
    this.item = this.modalItem
    this.tagsForAutoComplete = this.modalTagsForAutoComplete
    if (this.item.val04) {
      const aryTags = this.item.val04.split(',')
      aryTags.forEach(elem => {
        if (elem) {
          this.tags.push({ text: elem, tiClasses: ['ti-valid'] })
        }
      })
    }
  },

  methods: {
    /* =================================================================================
     * stopPropagation
     *   モーダル背景のクリックイベントがdiv階層内に伝播しないようにする
     * ============================================================================== */
    stopPropagation () {
      event.stopPropagation()
    },

    /* =================================================================================
     * checkSession
     *   認証セッションの状態をチェック
     * ============================================================================== */
    async checkSession () {
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: Start', mc.LOG_TYPE_I) : (() => { })()
      try {
        const myAuth = new MyAuth()
        const res = await myAuth.checkSession()
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: OK', mc.LOG_TYPE_I) : (() => { })()
          this.idToken = res.content.idToken
          this.username = res.content.username
        } else if (res.status === 'NOAUTH') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: NOAUTH', mc.LOG_TYPE_I) : (() => { })()
          this.WriteProcMsg('normal', res.content)
        }
      // モジュールmyAuth(promise)からのrejectや例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=checkSession: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to check session at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * updateMainDataCancel
     *   メインデータ更新処理を中止する
     * ============================================================================== */
    updateMainDataCancel () {
      this.$emit('modalCanceled')
    },

    /* =================================================================================
     * updateMainDataFix
     *   メインデータ更新処理を実行する
     * ============================================================================== */
    async updateMainDataFix (targetId) {
      mc.LOG_LEVEL ? console.log('%c info: Method=updateMainDataFix: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      if (this.item.val01 === '') {
        return false
      }
      let strTags = ''
      if (this.tags) {
        const aryTags = []
        this.tags.forEach(obj => { aryTags.push(obj.text) })
        strTags = aryTags.join(',')
        if (strTags) {
          strTags = `,${strTags},`
        }
      }
      const itemForUpdate = {
        val01: this.item.val01,
        val02: this.item.val02,
        val03: this.item.val03,
        val04: strTags
      }
      try {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { return false }
        const myData = new MyData()
        const res = await myData.updateMainData(this.idToken, targetId, itemForUpdate)
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=updateMainDataFix: OK', mc.LOG_TYPE_I) : (() => { })()
          this.$emit('modalFixed')
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=updateMainDataFix: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to update the data at the moment, try back later.')
      }
    },

    /* =================================================================================
     * deleteImageData
     *   画像データ削除処理を実行する
     * ============================================================================== */
    async deleteImageData (targetId) {
      mc.LOG_LEVEL ? console.log('%c info: Method=deleteImageData: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      // 認証セッションの状態をチェック
      await this.checkSession()
      if (!this.idToken) { return false }
      try {
        const myData = new MyData()
        const res = await myData.deleteImageData(this.idToken, targetId)
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=deleteImageData: OK', mc.LOG_TYPE_I) : (() => { })()
          this.imageFile = ''
          this.WriteProcMsg('normal', 'Image data deleted.')
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=deleteImageData: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.imageFile = ''
        this.WriteProcMsg('attention', 'Failed to delete image data.')
      }
    },

    /* =================================================================================
     * choiceImageData
     *   更新対象の画像ファイルを選択する
     * ============================================================================== */
    choiceImageData (event) {
      this.resetProcMsg()
      if (event) {
        this.imageFile = event.target.files[0]
      } else {
        this.imageFile = ''
      }
    },

    /* =================================================================================
     * updateImageData
     *   画像データ更新処理を実行する
     * ============================================================================== */
    async updateImageData (targetId) {
      mc.LOG_LEVEL ? console.log('%c info: Method=updateImageData: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      if (!this.imageFile || this.imageFile.type !== 'image/png' || this.imageFile.size === 0) {
        this.imageFile = ''
        return false
      }
      // 認証セッションの状態をチェック
      await this.checkSession()
      if (!this.idToken) { return false }
      try {
        const myData = new MyData()
        const res = await myData.updateImageData(this.idToken, targetId, this.imageFile)
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=updateImageData: OK', mc.LOG_TYPE_I) : (() => { })()
          this.imageFile = ''
          this.WriteProcMsg('normal', 'Image data updated.')
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=updateImageData: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.imageFile = ''
        this.WriteProcMsg('attention', 'Failed to update image data.')
      }
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  },

  computed: {
    /* =================================================================================
     * tagsForAutoCompleteFiltered
     *   Val04のタグ候補から、すでに入力済みのものを除外
     * ============================================================================== */
    tagsForAutoCompleteFiltered () {
      return this.tagsForAutoComplete.filter(i => {
        return i.text.toLocaleLowerCase().indexOf(this.tag.toLocaleLowerCase()) !== -1
      })
    }
  }
}
</script>

<style scoped lang="scss">
#overlay{
  z-index: 51;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
#content{
  z-index: 52;
  max-width: 18em;
  width: 100%;
  padding: 0.5em;
  border-radius: 0.25em;
  box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.3);
  background:#fff;
}
.outline-vertical {
  display: flex;
  flex-direction: column;
}
.block-vertical {
  display: flex;
  flex-direction: column;
}
.block-horizontal {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.hr-border {
  width: 100%;
  margin-top: 2.5em;
  border:none;
  border-top: 2px dotted #999;
  outline: none;
  height: 0.5em;
  text-align: center;
  overflow: visible;
}
.hr-border::after {
  content: 'Image File';
  height: 2em;
  position: relative;
  top: -1em;
  padding: 0 1em;
  line-height: 2em;
  background: #fff;
  color: #999;
  display: inline-block;
}
.input-holder {
  margin: 0.25em 0;
}
.button-holder {
  margin: 0.5em 0.1em 1em 0.1em;
}
</style>
